import { FETCH_SERVICE_VISITS_BOARD } from "@/modules/service-visits/store/service-visits.module";

export const serviceVisitBoardDatasetMixin = {
  data() {
    return {
      isPageLoading: true,
      statuses: [],
      itemStatuses: [],
      visits: []
    };
  },
  computed: {
    visitsByStatus() {
      return this.visits.reduce((groups, visit) => {
        const statusId = visit.statusId;
        groups[statusId] = groups[statusId] || [];
        groups[statusId].push(visit);
        return groups;
      }, {});
    },
    columns() {
      return this.statuses.map(status => ({
        status,
        visits: this.visitsByStatus[status.id] || []
      }));
    }
  },
  methods: {
    getBoard() {
      const apiParams = this.boardRequestParams();

      return this.$store.dispatch(FETCH_SERVICE_VISITS_BOARD, apiParams).then(data => {
        this.statuses = data.data.statuses || [];
        this.itemStatuses = data.data.itemStatuses || [];
        this.visits = data.data.visits || [];
        this.isPageLoading = false;
      });
    },
    boardRequestParams() {
      const params = this.activeServiceVisitFilters || {};

      if (!Object.keys(params).length) {
        return "";
      }

      return this.$url.transformParams(params);
    }
  }
};
